import { uniqBy } from 'lodash';
import { OrganizationRole, User } from 'types/schema-generated-types';
import { filterPublicOrgAssociationRoles } from 'utilities/organization-util';

const getOrgAssociationDetails = (
  user: User
): { organizationNames: string[]; organizationRoleNames: string[] } => {
  const organizationNames: string[] = [];
  let organizationRoles: OrganizationRole[] = [];

  user.organizationAssociations?.forEach(a => {
    organizationNames.push(a.organization.name);
    organizationRoles = organizationRoles.concat(a.organizationRoles);
  });

  return {
    organizationNames,
    organizationRoleNames: uniqBy(filterPublicOrgAssociationRoles(organizationRoles), 'id').map(
      r => r.displayName
    )
  };
};

export default getOrgAssociationDetails;
